import { createSelector } from '@reduxjs/toolkit';

import route from '@/lib/route';
import { AppState } from '@/redux/helper';
import { createSortedHabitatsSelector } from '@/redux/selectors/habitats';
import { createSelectCanAccessHabitat } from '@/redux/selectors/users';
import store from '@/redux/store';

import { setMembersOnlyWarningModalState } from '../MembersOnlyWarningModal/redux/actions';
import { setProductsPromptModalState } from '../products/ProductsPromptModal/redux/actions';
import { createSelectProductsPromptModalState } from '../products/ProductsPromptModal/redux/selectors';

export const buildHabitatURL = (zooSlug: string, habitatSlug: string, query?: string) =>
  `/h/${zooSlug}/${habitatSlug}${query ? `?${query}` : ''}`;

export const selectHabitatForProductsPromptModal = createSelector(
  createSortedHabitatsSelector(['online', 'lastMediaCapture', 'index', 'currentViewers', 'title']),
  (state: AppState) => state.user.subscription.habitatsAccessUntil,
  (habitats, habitatsAccessUntil) => {
    return habitats.find(
      (habitat) => !(habitatsAccessUntil?.[habitat._id] && Date.parse(habitatsAccessUntil[habitat._id]) > Date.now()),
    );
  },
);

export const routeToHabitat = (
  {
    id,
    slug,
    zooSlug,
    query,
  }: {
    id: string;
    slug: string;
    zooSlug: string;
    query?: string;
  },
  productsPromptModalState?: Parameters<typeof setProductsPromptModalState>[0],
) => {
  const state = store.getState();
  const canAccessHabitat = createSelectCanAccessHabitat(id)(state);
  const isLoggedIn = state.user.logged;
  if (!isLoggedIn) {
    store.dispatch(setMembersOnlyWarningModalState({ habitat: { id, slug, zooSlug }, type: 'habitat' }));
    return;
  }
  if (canAccessHabitat) {
    route(buildHabitatURL(zooSlug, slug, query));
    return;
  }
  const defaultState = createSelectProductsPromptModalState(id)(state);
  store.dispatch(setProductsPromptModalState({ ...defaultState, ...productsPromptModalState }));
};
